<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form @submit.prevent="submitWithdrawalForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('financial.accounts.accounting_withdrawal') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <RequiredText />
            <div class="form-group mb-5">
              <label class="form-label fs-6 text-black">{{ $t('financial.accounts.amount') }}</label>

              <VueNumberFormat v-model:value="formData.amount" class="form-control form-control-solid" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
              ></VueNumberFormat>
            </div>

            <div class="form-group">
              <label class="form-label fs-6 text-black">{{ $t('financial.accounts.reason') }}</label>
              <textarea v-model="formData.reason" class="form-control form-control-solid" rows="3" required></textarea>
            </div>

            <div class="col-6 my-auto mt-5">
              <div class="form-check form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox" id="flexCheckChecked"
                       v-model="formData.expense_created"
                       checked="checked" />
                <label class="form-check-label" for="flexCheckChecked">{{ $t('financial.accounts.expense_text') }}</label>
              </div>
            </div>

            <InputDate
                v-if="formData.expense_created"
                containerClass="mt-5"
                name="estimate-date"
                type="text"
                :label="$t('financial.accounts.modal_account.expense_date')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="false" 
                size="lg"
                :placeholder="$t('financial.accounts.modal_account.expense_date')"
                :maxDate="moment().format('DD-MM-YYYY')"
                v-model="formData.expense_date" />

            <Select2
              v-if="formData.expense_created"
              container-class="form-group mt-5"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              name="expense-reason"
              :label="$t('financial.accounts.modal_account.expense_reason')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('financial.accounts.modal_account.expense_reason')"
              v-model="formData.expense_reason"
              :IsInputGroup="true"
              :isRequired="false" 
              icon="bi bi-plus"
              :clickAddon="'#'"
            >
              <option v-for="reason in reasons" :value="reason.id" :key="reason.id">
                {{ reason.name }}
              </option>
            </Select2>

            <div class="mt-5" v-if="formData.expense_created">
              <label class=" font-weight-600 mb-3"> {{ $t('financial.accounts.modal_account.invoice') }} <span class="ms-2 text-danger">*</span></label>
              <UploadFile :id="'validate_file_upload'+id" size="5" v-model="formData.invoices"/>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoadingWithdrawal"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>
<script setup>

import {ref, defineProps, onMounted, watch, nextTick, defineEmits, computed} from 'vue'
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import Input from "@/components/Input";
import RequiredText from "@/components/RequiredText";
import VueNumberFormat from 'vue-number-format'
import InputDate from "@/components/InputDate.vue";
import Select2 from "@/components/Select2.vue";
import UploadFile from "@/components/UploadFile";
import moment from "moment";

const emits = defineEmits(['load'])

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    officeId: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {
        account_id: '',
        amount: 0,
        reason: "",
        expense_created: false,
        expense_reason: '',
        invoices: [],
        expense_amount: 0,
        expense_date: '',
        office_id: ''
      }
    },
})

const store = useStore()
const formData = ref(props.form)

const reasons = computed(() => store.getters['reason/reasons'])

function closeModal(){
  $('#'+props.id).modal('toggle')
}

const isLoadingWithdrawal = ref(false)

function submitWithdrawalForm(){
  isLoadingWithdrawal.value = true
  formData.value.office_id = props.officeId
  formData.value.expense_amount = formData.value.amount
  store.dispatch('accounts/createAccountWithdrawal', formData.value)
      .then((response) => {
          isLoadingWithdrawal.value = false
          emits('load')
          closeModal()
          formData.value.amount= 0,
          formData.value.reason= '',
          formData.value.expense_created= false
          formData.value.expense_amount= 0,
          formData.value.expense_reason= '',
          formData.value.expense_date= ''
          formData.value.invoices= []

          window.toastr['success'](i18n.global.t('notification.withdrawal_created_successfully'))
      })
      .catch(err => {
          isLoadingWithdrawal.value = false
      })
}


onMounted(() => {
  store.dispatch('reason/loadReasons', '') 
})
</script>